import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-518ec843"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "status-geolocation"
}
const _hoisted_4 = { class: "warning-geolocation" }
const _hoisted_5 = {
  key: 1,
  class: "status-geolocation"
}
const _hoisted_6 = { class: "error-geolocation" }
const _hoisted_7 = {
  key: 2,
  class: "suggestion-formatted-address"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "formkit-label" }, "Coordonnées pour l'adresse : ", -1))
const _hoisted_9 = { class: "suggestion-formatted-address-alert" }

import {ref, watch, computed, onMounted} from "vue";
    import ApiService from "@/_services/api.service";
    import { maximumDecimalsGeocoding } from "@/_services/geolocation/validations";
    import { useI18n } from "vue-i18n";
    import FormGeolocationCompletedByPartner from "@/components/forms/product/FormGeolocationCompletedByPartner.vue";
    import { useGeolocationStore } from "@/stores/geoloc/geolocationStore";
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'FormGeolocationEdition',
  props: {
        'index': {
            type: Number
        },
        'number': {
            type: Number
        },
        'reference': {
            type: Object,
            default: () => ({
                manualMethod: null,
                address: null,
                zipCode: null,
                city: null,
                country: null,
                latitude: null,
                longitude: null
            })
        },
        'optionsCountry': {
            type: Object
        },
        'isEditMode': {
            type: Boolean,
            default: false
        }
    },
  setup(__props) {

const props = __props;

    const { t } = useI18n();
    const geolocationStore = useGeolocationStore();
    
    const validationMessages = {
        maximumDecimalsGeocoding: `${t('ProductForm.Geolocation.validationMessage.maximumDecimalsGeocoding')}`,
        required: `${t('ProductForm.Geolocation.validationMessage.required')}`,
        min: `${t('ProductForm.Geolocation.validationMessage.min')}`,
        max: `${t('ProductForm.Geolocation.validationMessage.max')}`
    };
    
    // Define Props
    
    
    // Define computed properties that use the store
    const method = computed({
        get: () => geolocationStore.manualMethod,
        set: (value) => geolocationStore.updateField('manualMethod', value)
    });
    
    const address = computed({
        get: () => geolocationStore.address,
        set: (value) => geolocationStore.updateField('address', value)
    });
    
    const zipCode = computed({
        get: () => geolocationStore.zipCode,
        set: (value) => geolocationStore.updateField('zipCode', value)
    });
    
    const city = computed({
        get: () => geolocationStore.city,
        set: (value) => geolocationStore.updateField('city', value)
    });
    
    const country = computed({
        get: () => geolocationStore.country,
        set: (value) => {
            // Ensure country is a code, not a full name
            const countryCode = ensureCountryCode(value);
            geolocationStore.updateField('country', countryCode);
        }
    });
    
    const latitude = computed({
        get: () => geolocationStore.latitude,
        set: (value) => geolocationStore.updateField('latitude', value)
    });
    
    const longitude = computed({
        get: () => geolocationStore.longitude,
        set: (value) => geolocationStore.updateField('longitude', value)
    });
    
    const formattedAddress = computed({
        get: () => geolocationStore.formattedAddress,
        set: (value) => geolocationStore.updateField('formattedAddress', value)
    });
    
    // Define refs
    let initialStatus = ref<string|null>( props.reference.status ?? '');
    let activateRequestGeolocation = ref(false);
    let requestingGeolocation = ref(false);
    let warningRequestGeolocation = ref<string|null>(null);
    let errorRequestGeolocation = ref<string|null>(null);
    let addressFound = ref<string|null>(null);

    // Initialize the store with the reference data
    onMounted(() => {
        // Pass the edit mode to the store
        if (props.isEditMode) {
            geolocationStore.updateField('isEditMode', true);
        }
        
        // Ensure country code is correct in the reference data
        if (props.reference && props.reference.country) {
            props.reference.country = ensureCountryCode(props.reference.country);
        }
        
        geolocationStore.initGeolocationForm(props.reference);
    });

    const isEmpty = (val) => {
        return (undefined === val || null === val || '' === val);
    }
    
    if ('geocode_not_found_by_address' === initialStatus.value) {
        errorRequestGeolocation.value = `${t('ProductForm.Geolocation.zeroResultsGetGeocodeByAddress')}`;
    }

    if ('address_not_found_by_geocode' === initialStatus.value) {
        errorRequestGeolocation.value = `${t('ProductForm.Geolocation.zeroResultsGetAddressByGeocode')}`;
    }
    
    // Define functions
    const inputAddress = () => {
        resetMessages();
    
        geolocationStore.updateField('latitude', null);
        geolocationStore.updateField('longitude', null);
        geolocationStore.updateField('formattedAddress', null);
    
        // Only activate request if not in edit mode
        if (!props.isEditMode) {
            activateRequestGeolocation.value = canRequestGeocodeByAddress();
        }
    }
    
    const inputGeocode = () => {
        resetMessages();
    
        geolocationStore.updateField('address', null);
        geolocationStore.updateField('zipCode', null);
        geolocationStore.updateField('city', null);
        geolocationStore.updateField('country', null);
        geolocationStore.updateField('formattedAddress', null);
    
        // Only activate request if not in edit mode
        if (!props.isEditMode) {
            activateRequestGeolocation.value = canRequestAddressByGeocode();
        }
    }
    
    const resetMessages = () => {
        warningRequestGeolocation.value = null;
        errorRequestGeolocation.value = null;
        addressFound.value = null;
    }
    
    const canRequestGeocodeByAddress = () => {
        if (isEmpty(geolocationStore.address)) {
            return false;
        }
    
        if (isEmpty(geolocationStore.zipCode)) {
            return false;
        }
    
        if (isEmpty(geolocationStore.city)) {
            return false;
        }
    
        if (isEmpty(geolocationStore.country)) {
            return false;
        }
    
        return true;
    }
    
    const canRequestAddressByGeocode = () => {
        if (isEmpty(geolocationStore.latitude)) {
            return false;
        }
    
        if (isEmpty(geolocationStore.longitude)) {
            return false;
        }
    
        return true;
    }
    
    const beforeRequestGeolocation = () => {
        resetMessages();
        requestingGeolocation.value = true;
    }
    
    const getAddressByGeocode = async () => {
        beforeRequestGeolocation();
    
        // Request
        const payload = {
            'latitude': parseFloat(geolocationStore.latitude as string),
            'longitude': parseFloat(geolocationStore.longitude as string),
            'isEditMode': props.isEditMode
        }
    
        try {
            const response =  await ApiService.post("geolocation/reverse-geocoding", payload);
            const responseData = response.data.data;
    
            if ('OK' === responseData.status) {
                geolocationStore.updateField('address', responseData.address);
                geolocationStore.updateField('zipCode', responseData.zipCode);
                geolocationStore.updateField('city', responseData.city);
                geolocationStore.updateField('country', responseData.countryCode);
                geolocationStore.updateField('formattedAddress', responseData.formattedAddress);
    
                if (null === responseData.address || null === responseData.zipCode || null === responseData.city) {
                    warningRequestGeolocation.value = `${t('ProductForm.Geolocation.noCompleteResultGetAddressByGeocode')}`;
                }
    
                activateRequestGeolocation.value = false;
            } else if ('ZERO_RESULTS' === responseData.status) {
                errorRequestGeolocation.value = `${t('ProductForm.Geolocation.zeroResultsGetAddressByGeocode')}`;
                activateRequestGeolocation.value = false;
            } else {
                errorRequestGeolocation.value = `${t('ProductForm.Geolocation.errorGetAddressByGeocode')}`;
            }
        } catch (error) {
            errorRequestGeolocation.value = `${t('ProductForm.Geolocation.errorGetAddressByGeocode')}`;
        }
    
        requestingGeolocation.value = false;
    }
    
    // Function to ensure country is always a code, not a full name
    const ensureCountryCode = (country) => {
        // Mapping of country names to codes
        const countryMapping = {
            'France': 'FR',
            'Belgique': 'BE',
            'Suisse': 'CH',
            'Luxembourg': 'LU',
            'Allemagne': 'DE',
            'Italie': 'IT',
            'Espagne': 'ES'
        };
        
        // If country is a full name, convert it to code
        return countryMapping[country] || country;
    };

    const getGeocodeByAddress = async () => {
        beforeRequestGeolocation();

        // Ensure country is a code, not a full name
        const countryCode = ensureCountryCode(geolocationStore.country);

        // Request
        const payload = {
            'address': geolocationStore.address,
            'zipCode': geolocationStore.zipCode,
            'city': geolocationStore.city,
            'countryCode': countryCode,
            'isEditMode': props.isEditMode
        }
    
        try {
            const response =  await ApiService.post("geolocation/geocoding", payload);
            const geocode = response.data.data;
    
            if ('OK' === geocode.status) {
                geolocationStore.updateField('latitude', geocode.latitude);
                geolocationStore.updateField('longitude', geocode.longitude);
                geolocationStore.updateField('formattedAddress', geocode.formattedAddress);
    
                addressFound.value = geocode.formattedAddress;
                activateRequestGeolocation.value = false;
            } else if ('ZERO_RESULTS' === geocode.status) {
                errorRequestGeolocation.value = `${t('ProductForm.Geolocation.zeroResultsGetGeocodeByAddress')}`;
                activateRequestGeolocation.value = false;
            } else {
                errorRequestGeolocation.value = `${t('ProductForm.Geolocation.errorGetGeocodeByAddress')}`;
            }
        } catch (error) {
            errorRequestGeolocation.value = `${t('ProductForm.Geolocation.errorGetGeocodeByAddress')}`;
        }
    
        requestingGeolocation.value = false;
    }
    
    // Define watcher
    watch(
        method,
        (value) => {
            resetMessages();

            geolocationStore.updateField('address', null);
            geolocationStore.updateField('zipCode', null);
            geolocationStore.updateField('city', null);
            geolocationStore.updateField('country', null);
            geolocationStore.updateField('formattedAddress', null);
            geolocationStore.updateField('latitude', null);
            geolocationStore.updateField('longitude', null);
            
            // Only activate request if not in edit mode
            if (!props.isEditMode) {
                if ('address' === value) {
                    activateRequestGeolocation.value = canRequestGeocodeByAddress();
                } else if ('geocoding' === value) {
                    activateRequestGeolocation.value = canRequestAddressByGeocode();
                }
            }
        }
    );

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return ('completed_by_partner' === method.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(FormGeolocationCompletedByPartner, {
          index: props.index,
          number: props.number,
          reference: props.reference,
          optionsCountry: props.optionsCountry
        }, null, 8, ["index", "number", "reference", "optionsCountry"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_FormKit, {
          name: "manualMethod",
          modelValue: method.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((method).value = $event)),
          type: "radio",
          step: "any",
          label: "Méthode",
          options: {
                address: 'Adresse',
                geocoding: 'Latitude/Longitude'                    
            }
        }, null, 8, ["modelValue"]),
        (null !== _unref(warningRequestGeolocation))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(warningRequestGeolocation)), 1)
            ]))
          : _createCommentVNode("", true),
        (null !== _unref(errorRequestGeolocation))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("small", _hoisted_6, _toDisplayString(_unref(errorRequestGeolocation)), 1)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_FormKit, {
          modelValue: address.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((address).value = $event)),
          type: "text",
          step: "any",
          label: props.number + '. Adresse*',
          name: "address",
          placeholder: "Adresse",
          onKeyup: inputAddress
        }, null, 8, ["modelValue", "label"]), [
          [_vShow, 'address' === method.value]
        ]),
        _withDirectives(_createVNode(_component_FormKit, {
          modelValue: zipCode.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((zipCode).value = $event)),
          type: "text",
          step: "any",
          label: props.number + '. Code Postal*',
          name: "zipCode",
          placeholder: "Code Postal",
          onKeyup: inputAddress
        }, null, 8, ["modelValue", "label"]), [
          [_vShow, 'address' === method.value]
        ]),
        _withDirectives(_createVNode(_component_FormKit, {
          modelValue: city.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((city).value = $event)),
          type: "text",
          step: "any",
          label: props.number + '. Ville*',
          name: "city",
          placeholder: "Ville",
          onKeyup: inputAddress
        }, null, 8, ["modelValue", "label"]), [
          [_vShow, 'address' === method.value]
        ]),
        _withDirectives(_createVNode(_component_FormKit, {
          modelValue: country.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((country).value = $event)),
          type: "select",
          label: props.number + '. Pays*',
          name: "country",
          placeholder: "Pays",
          options: props.optionsCountry,
          onChange: _cache[5] || (_cache[5] = (event) => {
                // Ensure country is a code, not a full name
                country.value = ensureCountryCode(event.target ? event.target.value : event);
                inputAddress();
            })
        }, null, 8, ["modelValue", "label", "options"]), [
          [_vShow, 'address' === method.value]
        ]),
        _withDirectives(_createVNode(_component_FormKit, {
          modelValue: formattedAddress.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formattedAddress).value = $event)),
          disabled: "",
          type: "textarea",
          step: "any",
          rows: "2",
          label: props.number + '. Adresse correspondant aux coordonnées*',
          name: "formattedAddress",
          placeholder: "Adresse complète",
          validation: "required",
          "validation-messages": validationMessages,
          "validation-visibility": "submit"
        }, null, 8, ["modelValue", "label"]), [
          [_vShow, 'geocoding' === method.value]
        ]),
        ('address' === method.value && null !== _unref(addressFound))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(addressFound)), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("small", null, _toDisplayString(`${_unref(t)('ProductForm.Geolocation.alertVerificationAddress')}`), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_FormKit, {
          disabled: 'address' === method.value,
          modelValue: latitude.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((latitude).value = $event)),
          type: "number",
          step: "any",
          label: props.number + '. Latitude*',
          name: "latitude",
          placeholder: "Latitude",
          validation: "required|min:-90|max:90|maximumDecimalsGeocoding",
          "validation-rules": { maximumDecimalsGeocoding: _unref(maximumDecimalsGeocoding) },
          "validation-messages": validationMessages,
          "validation-visibility": "submit",
          onKeyup: inputGeocode
        }, null, 8, ["disabled", "modelValue", "label", "validation-rules"]),
        _createVNode(_component_FormKit, {
          disabled: 'address' === method.value,
          modelValue: longitude.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((longitude).value = $event)),
          type: "number",
          step: "any",
          label: props.number + '. Longitude*',
          name: "longitude",
          placeholder: "Longititude",
          validation: "required|min:-90|max:90|maximumDecimalsGeocoding",
          "validation-rules": { maximumDecimalsGeocoding: _unref(maximumDecimalsGeocoding) },
          "validation-messages": validationMessages,
          "validation-visibility": "submit",
          onKeyup: inputGeocode
        }, null, 8, ["disabled", "modelValue", "label", "validation-rules"]),
        ('geocoding' !== method.value)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 3,
              disabled: _unref(requestingGeolocation) || (!_unref(activateRequestGeolocation) && !props.isEditMode),
              type: "button",
              label: _unref(requestingGeolocation) ? `${_unref(t)('ProductForm.Geolocation.actions.requestingGeolocation')}` : `${_unref(t)('ProductForm.Geolocation.actions.getGeocode')}`,
              class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true }),
              onClick: getGeocodeByAddress
            }, null, 8, ["disabled", "label"]))
          : _createCommentVNode("", true),
        ('geocoding' === method.value)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 4,
              disabled: _unref(requestingGeolocation) || (!_unref(activateRequestGeolocation) && !props.isEditMode),
              type: "button",
              label: _unref(requestingGeolocation) ? `${_unref(t)('ProductForm.Geolocation.actions.requestingGeolocation')}` : `${_unref(t)('ProductForm.Geolocation.actions.getAddress')}`,
              class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true }),
              onClick: getAddressByGeocode
            }, null, 8, ["disabled", "label"]))
          : _createCommentVNode("", true)
      ]))
}
}

})